import React, { Component } from 'react';
import {setCurrentUserMix, setUserHasEditsToSave} from 'actions/index.js';
import ConditionedComponent from 'components/ConditionedComponent.js';
import UserMix from 'repos/UserMix.js';
import { connect } from "react-redux";
import { Button, InputGroup, InputGroupAddon, InputGroupText, Input } from 'reactstrap';

class MixNameComponent extends Component {

    constructor(props) {
        super(props);

        this.state = {
            nameValue: '',
            editingName: false,
        };
    }

    onNewMix() {
        let json = new UserMix().getJson();
        this.props.setCurrentUserMix(json);
        this.props.addEditedMix(new UserMix().fromJson(json));
        this.props.setUserHasEditsToSave(true);
        this.setState({nameValue: ''});
    }

    onKeyPress(e) {
        if (e.key === 'Enter') {
            this.chooseMixName();
        }
    }

    chooseMixName() {
        if (!this.props.isEditing) {
            return;
        }
        let mix = new UserMix().fromJson(this.props.currentMix);
        mix.name = this.state.nameValue;
        this.props.setCurrentUserMix(mix.getJson());
        this.props.setUserHasEditsToSave(true);
        this.setState({editingName: false});
    }

    getName() {
        return this.props.currentMix === undefined ?
            undefined :
            new UserMix().fromJson(this.props.currentMix).name;
    }

    onBackToMixes() {
        this.props.addEditedMix(new UserMix().fromJson(this.props.currentMix));
        this.props.setCurrentUserMix(undefined);
    }

    onClickName() {
        if (this.props.isEditing) {
            this.setState({editingName: true, nameValue: this.getName()});
        }
    }

    render() {
        if (this.props.currentMix === undefined && this.props.isEditing) {
            return (
                <div onClick={() => this.onNewMix()} className="new-mix-button">
                  NEW MIX
                </div>
            );
        }

        return (
            <div className="mix-name-container">
              <ConditionedComponent condition={this.props.isEditing && (this.state.editingName || this.getName() === undefined)}>
                <InputGroup className="tag-sound-input mix-name-container">
                  <Input
                    onChange={(event) => {this.state.nameValue = event.target.value; this.setState(this.state);}}
                    value={this.state.nameValue}
                    onKeyUp={(e) => this.onKeyPress(e)}
                    placeholder="Choose a mix name" className="tag-sound-input-box"/>
                  <InputGroupAddon addonType="append">
                    <Button size="sm" onClick={() => this.chooseMixName()} color="secondary">Done</Button>
                  </InputGroupAddon>
                </InputGroup>
              </ConditionedComponent>
              <ConditionedComponent condition={!this.state.editingName && this.getName() !== undefined}>
                <div className="mix-name-and-back">
                  <div
                    onClick={() => this.onClickName()}
                    className="mix-name">
                    {this.getName()}
                  </div>
                  <div
                    onClick={() => this.onBackToMixes()}
                    className="back-to-mixes">
                    BACK 
                  </div>
 
                </div>
             </ConditionedComponent>
              <div className="clear-fix"></div>
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setCurrentUserMix: mix => dispatch(setCurrentUserMix(mix)),
        setUserHasEditsToSave: t => dispatch(setUserHasEditsToSave(t)),
    };
};
const mapStateToProps = (state, props) => {
    return {
        currentMix: state.user.currentMix,
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(MixNameComponent);
